import { useEffect, useRef } from "react";
const stapel = [];
let horcherHaengt = false;
function beiTaste(ereignis) {
    if (ereignis.key !== "Escape")
        return;
    /*
     * Zwei Escapes, die uns nichts angehen (Fixrunde 2):
     *
     *  1. `isComposing` — der Benutzer schreibt gerade über eine Eingabemethode (japanisch,
     *     chinesisch, koreanisch; auf jedem System auch die Zeichenpalette). Escape bricht
     *     dort die KOMPOSITION ab und ist eine Eingabe, keine Ansage an die Anwendung. Wer
     *     mitten im Wort ein Menü zugeklappt bekäme, hätte zweimal verloren: den Text und
     *     den Ort.
     *  2. `defaultPrevented` — ein näherer Behandler hat das Escape schon verbraucht (ein
     *     `<dialog>`, ein Eingabefeld mit eigener Abbruchgeste, ein fremdes Bauteil). Der
     *     Stapel ordnet die Schichten, die sich BEI IHM angemeldet haben; er darf nicht auch
     *     noch denen ins Wort fallen, die näher am Ereignis sitzen.
     *     Seit der Stapel in der CAPTURE-Phase horcht (ME-Etappe 2), greift das nur noch
     *     für ein Escape, das schon VOR dem Dokument verbraucht wurde (Horcher am Fenster in
     *     der Capture-Phase, ein schon verbraucht ausgelöstes Ereignis). Nähere Behandler in
     *     der Bubble-Phase kommen nach dem Stapel.
     */
    if (ereignis.isComposing || ereignis.defaultPrevented)
        return;
    const oberste = stapel[stapel.length - 1];
    if (oberste === undefined)
        return;
    oberste.beiEscape();
    /*
     * Verbraucht melden (ME-Etappe 2, Fixrunde 1 zu Aufgabe 2): Elemente aus me-design, die
     * selbst am Dokument auf Escape horchen — `me-spalten` faltet damit seine überlagernde
     * Kontextspalte —, lassen ein Escape mit `defaultPrevented` in Ruhe. So schliesst ein
     * Escape nur die oberste Kundeninfo-Schicht (Menü, Dialog) und nicht zugleich die
     * Kontextspalte darunter; erst das nächste Escape erreicht das Element.
     */
    ereignis.preventDefault();
}
function anmelden(ebene) {
    stapel.push(ebene);
    if (horcherHaengt)
        return;
    // CAPTURE-Phase: Der Stapel muss VOR den Horchern der me-design-Elemente am Dokument
    // (Bubble-Phase) entscheiden, damit sein `preventDefault()` dort ankommt — gleich, wer
    // sich zuerst am Dokument angemeldet hat. Kundeninfo selbst hat keine näheren
    // Escape-Behandler (Stand 08.10.2026); ein vorab verbrauchtes Escape bleibt ausgenommen.
    document.addEventListener("keydown", beiTaste, true);
    horcherHaengt = true;
}
function abmelden(ebene) {
    // lastIndexOf und nicht indexOf: Zwei Schichten sind nie dasselbe Objekt, aber wenn sie
    // es je wären, gehört die ZULETZT angemeldete abgeräumt — sonst nähme das Abräumen der
    // einen der anderen ihren Platz im Stapel weg.
    const stelle = stapel.lastIndexOf(ebene);
    if (stelle >= 0)
        stapel.splice(stelle, 1);
    if (stapel.length > 0 || !horcherHaengt)
        return;
    document.removeEventListener("keydown", beiTaste, true);
    horcherHaengt = false;
}
/**
 * Meldet diese Schicht am Escape-Stapel an, solange `aktiv` gilt.
 *
 * Der Horcher hängt am DOKUMENT und nicht am eigenen Rahmen: Er soll auch greifen, wenn der
 * Fokus gerade nirgendwo steht (auf `<body>`) — der Normalfall, nachdem etwas per
 * Zeigergeste geöffnet wurde.
 *
 * `beiEscape` steht bewusst NICHT in der Abhängigkeitsliste: Aufrufer schreiben den Rückruf
 * fast immer als Inline-Funktion, und seine wechselnde Identität würde die Schicht bei
 * jedem Neuzeichnen ab- und wieder anmelden — sie spränge damit an die Spitze des Stapels,
 * ohne dass jemand etwas geöffnet hätte. Eine Ref hält stattdessen immer den neuesten
 * Rückruf (dieselbe Überlegung wie in useFocusTrap.ts).
 */
export function useEscapeEbene(aktiv, beiEscape) {
    const rueckruf = useRef(beiEscape);
    rueckruf.current = beiEscape;
    useEffect(() => {
        if (!aktiv)
            return undefined;
        const ebene = { beiEscape: () => rueckruf.current() };
        anmelden(ebene);
        return () => abmelden(ebene);
    }, [aktiv]);
}
/**
 * Wie viele Schichten gerade angemeldet sind — NUR für Tests.
 *
 * Sie steht hier, weil der Stapel Modulzustand ist: Ohne diesen Blick könnte kein Test
 * zeigen, dass eine Schicht sich beim Schliessen wirklich abmeldet, und ein Leck würde
 * erst auffallen, wenn Escape irgendwann gar nichts mehr tut.
 */
export function offeneEbenen() {
    return stapel.length;
}
//# sourceMappingURL=useEscapeEbene.js.map